import firebase from 'firebase/app'
import 'firebase/functions'
import connyPreview from './connyPreviewData'

export const connyPreviewEnabled = process.env.NODE_ENV === 'development' && process.env.VUE_APP_CONNY_PREVIEW === '1'

function standalonePreviewEnabled () {
  return connyPreviewEnabled && typeof window !== 'undefined' && /(?:^|[?&])preview=standalone(?:&|$)/.test(window.location.search)
}

function currentUserkey () {
  try {
    const user = JSON.parse(localStorage.getItem('userData') || '{}')
    return user.key || ''
  } catch (error) {
    return ''
  }
}

async function callConny (name, payload = {}) {
  const userkey = currentUserkey()
  if (!userkey) throw new Error('ไม่พบข้อมูลผู้ใช้ กรุณาเข้าสู่ระบบอีกครั้ง')
  const callable = firebase.app().functions('asia-east2').httpsCallable(name)
  const response = await callable(Object.assign({ userkey }, payload))
  return response.data
}

export function connyErrorMessage (error) {
  const code = String(error && error.code ? error.code : '')
  const message = String(error && error.message ? error.message : '')
  if (/feature is not enabled/i.test(message)) return 'ระบบสัตว์เลี้ยงยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('already-exists') && /mission/i.test(message)) return 'รับรางวัลภารกิจนี้แล้ว'
  if (code.includes('already-exists') && /played/i.test(message)) return 'เล่นด้วยกันแล้ววันนี้ กลับมาใหม่พรุ่งนี้นะ'
  if (code.includes('already-exists') && /checked in/i.test(message)) return 'ให้อาหารแล้ววันนี้ กลับมาใหม่พรุ่งนี้นะ'
  if (code.includes('already-exists')) return 'รับสิทธิ์นี้ไปแล้ว'
  if (code.includes('unauthenticated')) return 'กรุณาเข้าสู่ระบบอีกครั้ง'
  if (code.includes('permission-denied')) return 'ระบบสัตว์เลี้ยงยังไม่เปิดให้บัญชีนี้ใช้งาน'
  if (code.includes('failed-precondition') && /coin/i.test(message)) return 'เหรียญไม่เพียงพอสำหรับเปลี่ยนชื่อ'
  if (code.includes('failed-precondition')) return 'ยังทำเงื่อนไขไม่ครบ กรุณาตรวจสอบอีกครั้ง'
  if (code.includes('unavailable')) return 'เชื่อมต่อไม่สำเร็จ กรุณาลองอีกครั้ง'
  return 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
}

export default {
  // Deposit and reward summaries must always come from the backend.
  getHomeStatus: () => callConny('getConnyHomeStatus'),
  getPetStatus: () => connyPreviewEnabled ? connyPreview.getPetStatus() : callConny('getConnyPetStatus'),
  play: () => connyPreviewEnabled ? connyPreview.play() : callConny('playWithConnyPet'),
  updateProfile: payload => connyPreviewEnabled ? connyPreview.updateProfile(payload) : callConny('updateConnyPetProfile', payload),
  getCheckinStatus: () => standalonePreviewEnabled() ? connyPreview.getCheckinStatus() : callConny('getConnyCheckinStatus'),
  claimCheckin: () => standalonePreviewEnabled() ? connyPreview.claimCheckin() : callConny('claimConnyDailyCheckin'),
  getMissionsStatus: () => standalonePreviewEnabled() ? connyPreview.getMissionsStatus() : callConny('getConnyMissionsStatus'),
  claimMission: missionId => standalonePreviewEnabled() ? connyPreview.claimMission(missionId) : callConny('claimConnyMissionReward', { missionId })
}
